import { render, staticRenderFns } from "./SimpleInput.vue?vue&type=template&id=665aba13"
import script from "./SimpleInput.vue?vue&type=script&lang=js"
export * from "./SimpleInput.vue?vue&type=script&lang=js"
import style0 from "./SimpleInput.vue?vue&type=style&index=0&id=665aba13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports